import { useEffect, useState } from 'react';

/** Elapsed time of the running session as m:ss, updated every second. */
export function useElapsed(startedAt: number | undefined): string {
  const [now, setNow] = useState(() => performance.now());
  useEffect(() => {
    if (startedAt === undefined) return undefined;
    const timer = setInterval(() => {
      setNow(performance.now());
    }, 1000);
    return () => {
      clearInterval(timer);
    };
  }, [startedAt]);
  const s = startedAt === undefined ? 0 : Math.max(0, Math.floor((now - startedAt) / 1000));
  return `${String(Math.floor(s / 60))}:${String(s % 60).padStart(2, '0')}`;
}
